import { customAlphabet } from 'nanoid/non-secure';

/**
 * Generates a client-side unique id for list keys and local record identity
 * (`key`, `_key`, `_uid`).
 *
 * Mirrors customer-frontend's `utils/stringUtils/uniqID` so ids look the same
 * across our frontends. The alphabet is nolookalikesSafe from
 * https://www.npmjs.com/package/nanoid-dictionary — alphanumeric only, so an id
 * survives `decamelizeKeys` unchanged and stays safe in a DOM selector.
 *
 * Import this rather than reaching for a generator directly: the previous one
 * (`uniqid`) read `os.networkInterfaces()` at module scope, which threw under
 * Vite's browser build and broke whole lazy chunks (EUCS-779).
 */
export const uniqID = customAlphabet('6789BCDFGHJKLMNPQRTWbcdfghjkmnpqrtwz', 10);
